const addCopyTagsListener = () => {
  document.addEventListener('click', (evt) => {
    const $target = evt.target;
    const $copyBtn = $target.closest('.js-copy-btn') || false;
    const $copyContainer = $target.closest('.js-copy-tags') || false;

    if ($copyBtn && $copyContainer) {
      const $tagNodes = $copyContainer.querySelectorAll('.js-tag');
      const $textInput = $copyContainer.querySelector('.js-copy-text');
      const $btnText = $copyBtn.querySelector('span');
      const clipboardTextArray = [];
      $tagNodes.forEach((tag) => {
        clipboardTextArray.push(tag.textContent);
      });

      $textInput.value = clipboardTextArray.join(' ');
      $textInput.select();
      document.execCommand('copy');
      $textInput.value = '';
      $textInput.blur();
      $btnText.textContent = 'Скопировано!';

      setTimeout(() => {
        $btnText.textContent = 'Скопировать теги';
      }, 2000);
    }
  });
};

export {addCopyTagsListener};
